import { createTheme, ThemeOptions } from "@mui/material/styles";
// @ts-ignore
import { themeOptions } from "@theme";
export default createTheme(themeOptions as ThemeOptions);
